'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIDialogHeaderImage = require('UIComponents/dialog/UIDialogHeaderImage');

var _UIDialogHeaderImage2 = _interopRequireDefault(_UIDialogHeaderImage);

var _UIDialogFooter = require('UIComponents/dialog/UIDialogFooter');

var _UIDialogFooter2 = _interopRequireDefault(_UIDialogFooter);

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

var _UIDialogHeader = require('UIComponents/dialog/UIDialogHeader');

var _UIDialogHeader2 = _interopRequireDefault(_UIDialogHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRIAL = _sources.sourceKeys.TRIAL;

var LANG_ROUTE = 'upgrades.activationModal';

var ActivationSuccessModal = function ActivationSuccessModal(_ref) {
  var type = _ref.type,
      onSuccess = _ref.onSuccess,
      header = _ref.header,
      subText = _ref.subText;

  var isTrialModal = type === TRIAL;

  return _react2.default.createElement(
    _UIModal2.default,
    { centered: true, size: 'auto', use: 'success', width: 600 },
    _react2.default.createElement(
      _UIDialogHeaderImage2.default,
      { offsetBottom: -30, offsetTop: 40 },
      _react2.default.createElement(_UIIllustration2.default, { name: 'success', width: 118 })
    ),
    _react2.default.createElement(
      _UIDialogHeader2.default,
      null,
      _react2.default.createElement(
        'h2',
        null,
        header || _react2.default.createElement(_FormattedMessage2.default, {
          message: LANG_ROUTE + '.' + (isTrialModal ? 'trialTitle' : 'productTitle')
        })
      )
    ),
    _react2.default.createElement(
      _UIDialogBody2.default,
      null,
      subText && _react2.default.createElement(
        'p',
        null,
        subText
      )
    ),
    _react2.default.createElement(
      _UIDialogFooter2.default,
      { align: 'center' },
      _react2.default.createElement(
        _UIButton2.default,
        { use: 'primary', onClick: onSuccess },
        _react2.default.createElement(_FormattedMessage2.default, { message: LANG_ROUTE + '.getStarted' })
      )
    )
  );
};

ActivationSuccessModal.propTypes = {
  type: _react.PropTypes.string.isRequired,
  onSuccess: _react.PropTypes.func,
  header: _react.PropTypes.node,
  subText: _react.PropTypes.node
};

exports.default = ActivationSuccessModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/ActivationSuccessModal.js
// module id = 365
// module chunks = 3 4 5